import ProfileModel from "../../../Profile/Models/ProfileModel";
import EventGamePredictionFixturesModel from "./EventGamePredictionFixturesModel";
import EventGameTiebreaker from "./EventGameTiebreaker";

export enum EventGamePredictionStatusEnum {
  /**
   * ACTIVE Predictions are made.
   */
  ACTIVE = "ACTIVE",
  /**
   * Settled WON all Predictions are correct.
   */
  WON = "WON",
  /**
   * Settled LOST all Prediction are incorrect.
   */
  LOST = "LOST",
  /**
   * Settled PARTIAL_WON (obtained some points) not all Predictions are correct.
   */
  PARTIALLY_WON = "PARTIALLY_WON",
  /**
   * CANCELED Predictions because game was canceled.
   */
  CANCELED = "CANCELED",
}

export default class EventGamePredictionModel {
  public id: string = "";
  public profileId: string = "";
  public profileModel: ProfileModel | null = null;
  public gameId: string = "";
  public gamePoints: number | null = null;
  public bonusPoints: number | null = null;
  public totalPoints: number | null = null;
  public position: number | null = null;
  public status: EventGamePredictionStatusEnum =
    EventGamePredictionStatusEnum.ACTIVE;
  public fixtures: EventGamePredictionFixturesModel[] = [];
  public tiebreaker: EventGameTiebreaker = new EventGameTiebreaker();
  public createdAt: string = "";
  public updatedAt: string = "";
}
